import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';
import { Link } from 'react-router-dom';
import ErrorIcon from '../../assets/images/icon_error_messages.gif';
import LoginShema from './schema';
import request, { apiHost } from '../utils/request';
import ValidateLoader from '../UI/validateLoader';
import EN from '../../EN.json';
import FR from '../../FR.json';

const Login = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const [isError, setError] = useState(false);
  const {
    USERS: {
      USER_AUTHENTICATION: {
        labels,
        ERRORS_MESSAGES: { GENERIC_ERROR_HEADING, GENERIC_ERROR_MESSAGE }
      }
    }
  } = localStorage.getItem('locale') === 'FR' ? FR : EN;

  const getUserProfile = () => {
    return request.get('/users/profile');
  };

  useEffect(() => {
    const locale = localStorage.getItem('locale');
    const authenticate = async () => {
      const redirect = () => {
        history.push('/orders');
        // HACK to fix: header issue ideally
        // location.reload();
        window.location.reload();
      };

      // check if already logged in
      if (request.getToken() && request.getProfile()) redirect();
      else {
        //  check if user is redirected from passport with token in params
        const queryData = new URLSearchParams(history.location.search);
        const token = queryData.get('token');

        if (token) {
          request.setToken(token);
          try {
            const { data } = await getUserProfile();
            request.setProfile(data);
            request.setSSOLoginState(true);
            redirect();
          } catch (err) {
            setError(true);
            localStorage.clear();
            localStorage.setItem('locale', locale);
          }
        } else {
          localStorage.clear();
          localStorage.setItem('locale', locale);
        }
      }
    };
    authenticate();
  }, [request.getToken()]);

  const loginRequest = values => {
    setLoading(true);
    const { email, password } = values;
    request
      .post('/users/login', { email, password })
      .then(response => {
        const { token } = response && response.data;
        request.setToken(token);
        return getUserProfile();
      })
      .catch(() => {
        setError(true);
        setLoading(false);
      })
      .then(({ data }) => {
        request.setProfile(data);
        setLoading(false);
      });
  };

  return (
    <>
      <Formik
        initialValues={{
          email: '',
          password: ''
        }}
        validationSchema={LoginShema}
        onSubmit={values => {
          loginRequest(values);
        }}
      >
        {({ errors, touched }) => (
          <Form>
            <div id="main" style={{ marginTop: '54px', paddingBottom: '93px' }}>
              <div id="main-wrapper">
                <div id="main-content">
                  <h2>
                    <div id="main-content-title">
                      <span
                        className="frg-icon icon-user-profile-inverted"
                        style={{ paddingRight: 10, fontSize: 26 }}
                      />
                      {labels.TELUS_HEADING}
                    </div>
                  </h2>
                  {isError ? (
                    <div
                      id="error-message-content"
                      style={{ display: 'block' }}
                    >
                      <div id="error-message-icon">
                        <img src={ErrorIcon} alt="error_icon" />
                      </div>
                      <div id="error-message-title">
                        <span className="frg-body-font-23px">
                          {GENERIC_ERROR_HEADING}
                        </span>
                      </div>
                      <div className="clear" />
                      <div id="error-message-message">
                        <span className="frg-body-font-14px">
                          {GENERIC_ERROR_MESSAGE}
                          <br />
                        </span>
                      </div>
                    </div>
                  ) : null}
                  <div
                    id="sso-content-container"
                    style={{ textAlign: 'center' }}
                  >
                    <span>
                      <button
                        type="button"
                        className="frg-button button-wide color-purple"
                        onClick={() =>
                          window.location.replace(`${apiHost}/users/sso-login`)
                        }
                        style={{ marginBottom: '10px' }}
                      >
                        {labels.SSO_LOGIN_LABEL}
                      </button>
                    </span>
                    <span style={{}}>OR</span>
                  </div>
                  <div id="main-content-login">
                    <div
                      id="username_container"
                      style={{ position: 'relative' }}
                    >
                      <div className="main-content-form-headers">
                        <span className="frg-body-font-14px">
                          {labels.USERNAME}
                        </span>
                      </div>
                      <div
                        style={{ position: 'relative' }}
                        className={`input-container ${
                          errors.email && touched.email ? 'error' : ''
                        }`}
                      >
                        <Field
                          type="email"
                          name="email"
                          style={{ width: '100%' }}
                          className="select-style"
                          placeholder={labels.EMAIL}
                        />

                        <>
                          <div className="error_messages">
                            <span className="frg-body-font-14px">
                              {errors.email}
                            </span>
                          </div>
                          <div
                            id="username_error_icon"
                            className="error_messages_icon"
                          >
                            <img src={ErrorIcon} alt="error_icon" />
                          </div>
                        </>
                      </div>
                    </div>
                    <div style={{ marginTop: 15, position: 'relative' }}>
                      <div className="main-content-form-headers">
                        <span className="frg-body-font-14px">
                          {labels.USER_LOGIN_PASSWORD} (
                          <Link to="/forgot-password" style={{ fontSize: 12 }}>
                            {labels.USER_FORGOT_PASSWORD}
                          </Link>
                          )
                        </span>
                      </div>
                      <div
                        style={{ position: 'relative' }}
                        className={`input-container ${
                          errors.password && touched.password ? 'error' : ''
                        }`}
                      >
                        <Field
                          type="password"
                          name="password"
                          style={{ width: '100%' }}
                          className="select-style"
                          placeholder={labels.USER_LOGIN_PASSWORD}
                        />
                        <>
                          <div className="error_messages">
                            <span className="frg-body-font-14px">
                              {errors.password}
                            </span>
                          </div>
                          <div
                            id="username_error_icon"
                            className="error_messages_icon"
                          >
                            <img src={ErrorIcon} alt="error_icon" />
                          </div>
                        </>
                      </div>
                    </div>
                    {loading && (
                      <ValidateLoader
                        message={
                          localStorage.getItem('locale') === 'FR'
                            ? 'Vérifier votre identité'
                            : 'Verifying your identity...'
                        }
                      />
                    )}
                    <div style={{ marginTop: 20 }}>
                      <span>
                        <button
                          type="submit"
                          className="frg-button button-wide color-green"
                        >
                          {labels.CONTINUE}
                        </button>
                      </span>
                    </div>
                  </div>
                  <div align="center" id="main-content-register">
                    <div>
                      <span className="frg-body-font-17px">
                        {labels.USER_LOGIN_BOTTOM}
                      </span>
                    </div>
                    <div>
                      <span className="frg-body-font-14px">
                        <Link to="/registration">
                          {labels.REGISTER_LABEL_LOGIN}
                        </Link>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

Login.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired
  }).isRequired
};
export default Login;
